<template>
  <div>
    <BreadCrumb PageTitle="Wholesale Customer Details" :IntermediaryItems="breadcrumbItems" />
    <MerchantCustomerDetails />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import MerchantCustomerDetails from "../../components/Wholesale/MerchantCustomerDetails.vue";

export default defineComponent({
  name: "MerchantCustomerDetailsPage",
  components: {
    BreadCrumb,
    MerchantCustomerDetails,
  },
  data() {
    return {
      breadcrumbItems: [
        {
          name: 'Wholesale Customers List',
          to: '/wholesale/customers'
        }
      ]
    }
  }
});
</script>